import type { BaseKeyFunction, DisplayType } from "../../../lib";

export type KeyFavoritesProps = { displayType: DisplayType };

export const keyFavorites: BaseKeyFunction<KeyFavoritesProps> = ({
  displayType,
}) => ["favorites", { displayType }];
